import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const domain = window.location.hostname=== 'localhost' ? process.env.REACT_APP_HOTEL_DOMAIN : window.location.hostname;
  config.headers['X-Hotel-Domain'] = domain;
  const token = localStorage.getItem('xhotel_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// Unwrap response — return data directly, throw readable error
apiClient.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body?.success === false) {
      const message = body?.errors?.[0] || 'Something went wrong';
      throw new Error(message);
    }
    return body?.data ?? body;
  },
  (error) => {
    const data = error?.response?.data;
    const message =
      (data?.errors?.[0]) ||
      (typeof data === 'string' && data.trim() ? data.trim() : null) ||
      error?.message ||
      'Network error. Please try again.';
    throw new Error(message);
  }
);

export default apiClient;
